<template>
  <div @click="gotoDetail()" class="mt-1">
    <span class="ml-2 mt-2">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="#6e8ca0
        

"
        width="21px"
        height="21px"
      >
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          d="M12 6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0 10c2.7 0 5.8 1.29 6 2H6c.23-.72 3.31-2 6-2m0-12C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 10c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
        />
      </svg>
      <!-- <button @click="sayHi">Edit Item</button> -->
    </span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  created() {},
  methods: {
    gotoDetail() {
      if (this.nowSlug == "second") {
        this.$store.dispatch("general/getRenderDetail", {
          path: this.nowSlug,
          detail: "comp_card",
          id_user: this.params.value
        });
      } else {
        this.$store.dispatch("general/getRenderDetail", {
          path: this.nowSlug,
          detail: null,
          id_user: this.params.value
        });
      }
      this.$store.commit("general/GET_ID_USER", this.params.value);
      this.$router.push("/detail");
    }
  },
  computed: {
    ...mapGetters({
      nowPage: "getNowPage",
      nowSlug: "getNowSlug",
      tabActive: "general/tabActive"
    })
  },
  updated() {
    // console.log("nowPage", this.nowPage);
  }
};
</script>
